import { useTranslation } from 'react-i18next';
import Alert from '@/assets/images/icons/toast/alert.svg?react';
import Caution from '@/assets/images/icons/toast/caution.svg?react';
import Info from '@/assets/images/icons/toast/info.svg?react';
import Success from '@/assets/images/icons/toast/success.svg?react';
import { removeToast, useToastStore } from '@/stores/toast';
import { queryStringToRecord } from '@/utils/query-string';

const ToastIcon = ({ type, className }: { type: 'info' | 'success' | 'warning' | 'error'; className?: string }) => {
  switch (type) {
    case 'info':
      return <Info className={className} />;
    case 'success':
      return <Success className={className} />;
    case 'warning':
      return <Caution className={className} />;
    case 'error':
      return <Alert className={className} />;
  }
};

export default function AppToast() {
  const { t } = useTranslation();
  const toasts = useToastStore((s) => s.toasts);

  return (
    <div className='toast toast-center toast-top z-100 w-full items-center whitespace-normal top-safe-offset-20 -translate-x-1/2 pointer-events-none'>
      {toasts.map((toast) => {
        let message = toast.message ?? '';

        if (toast.translateMessage) {
          if (message.includes('|')) {
            const [key = '', qs = ''] = message.split('|');
            const params = queryStringToRecord(qs);
            message = t(key, params);
          } else {
            message = t(message);
          }
        }

        return (
          <div
            key={toast.id}
            className='flex max-w-screen-xs items-center gap-x-2 overflow-hidden rounded-lg bg-white px-4 py-2 shadow-toast mode-embedded:bg-metal-700 mode-embedded:text-white'
            onClick={() => removeToast(toast.id)}>
            <div className='shrink-0'>
              <ToastIcon
                type={toast.type}
                className='size-5'
              />
            </div>
            <div className='line-clamp-2 text-sm'>{message}</div>
          </div>
        );
      })}
    </div>
  );
}
